/**
 * Size Guide popup
 * Opens/closes the size chart modal triggered from the product page's
 * "Size Guide" link next to the Size option.
 *
 * Modals are moved to document.body on load: Dawn's scroll-reveal
 * animation wrapper (.scroll-trigger) sets a CSS transform on the
 * product info column, which creates a new containing block for any
 * `position: fixed` descendant — without this, the modal would be
 * sized/positioned relative to that column instead of the viewport.
 */
document.querySelectorAll('.size-guide-modal').forEach(function (modal) {
  document.body.appendChild(modal);
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-size-guide-target]');
  if (trigger) {
    const modal = document.getElementById(trigger.getAttribute('data-size-guide-target'));
    if (modal) {
      modal.hidden = false;
      document.body.classList.add('size-guide-modal-open');
    }
    return;
  }

  const closeEl = event.target.closest('[data-size-guide-close]');
  if (closeEl) {
    const modal = closeEl.closest('.size-guide-modal');
    if (modal) {
      modal.hidden = true;
      document.body.classList.remove('size-guide-modal-open');
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('.size-guide-modal:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
      document.body.classList.remove('size-guide-modal-open');
    });
  }
});
